import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined, } from '@ant-design/icons'
import axios, { axiosTable } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

interface State {
    articleType: object[],
    data: object[],
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    fetchOtherParams: {
        title: string | null,
        type_name: string | null,
        start_create_date: string | null,
        end_create_date: string | null
    },
    formParams: {
        item_type: string | null
    },
    rangeDate: any,
    offShelfVisible: boolean,
    addVisible: false
}

export default class ArticleList extends React.Component {
    state: State = {
        articleType: [],
        data: [],
        rangeDate: null,
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        fetchOtherParams: {
            title: null,
            type_name: null,
            start_create_date: null,
            end_create_date: null
        },
        formParams: {
            item_type: null
        },
        offShelfVisible: false,
        addVisible: false
    }

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
        this.fetchType()
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    handleSelectChange(value: string) {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.type_name = value

        this.setState({
            fetchOtherParams
        })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.title = e.target.value

        this.setState({ fetchOtherParams })
    }


    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        pagination.pageSize = antPagination.pageSize

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manage_center/article/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            const { pagination } = this.state
            pagination.total = response.total
            pagination.pageSize = response.size
            pagination.current = response.current

            this.setState({
                pagination,
                data: response.records
            })
        })
    }

    resetForm() {
        let { fetchOtherParams } = this.state
        fetchOtherParams.type_name = null
        fetchOtherParams.title = null
        fetchOtherParams.start_create_date = null
        fetchOtherParams.end_create_date = null

        this.setState({ fetchOtherParams, rangeDate: null })
        this.selectState('')
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    changeStatus(item: any, status: number) {
        axios.post('/manage_center/article/update_status', { id: item.id, is_published: status }).then(res => {
            this.selectState('current')
        })
    }

    changeIsTop(item: any, status: number) {
        axios.post('/manage_center/article/update_top', { id: item.id, is_top: status }).then(res => {
            this.selectState('current')
        })
    }

    fetchType() {
        axiosTable.get('/manage_center/article_type/list', {}).then((res: any) => {
            this.setState({
                articleType: res
            })
        })
    }

    pickerTime(dateArr: any) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state

        if (dateArr) {
            fetchOtherParams.start_create_date = dateArr[0].format('YYYY-MM-DD')
            fetchOtherParams.end_create_date = dateArr[1].format('YYYY-MM-DD')

        } else {
            fetchOtherParams.start_create_date = undefined
            fetchOtherParams.end_create_date = undefined
        }

        this.setState({ rangeDate: dateArr, ...fetchOtherParams })
    }

    render() {
        let { title, type_name } = this.state.fetchOtherParams
        let { articleType } = this.state;

        return (<div className="common-page">
            {/* 管理中心 -> 文章管理 -> 文章列表 */}
            <BreadCrumb position={['管理中心', '文章列表']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: '150px' }} allowClear={true} value={type_name as string} onChange={this.handleSelectChange.bind(this)} placeholder="文章分类">
                        {
                            articleType.map((item: any) => {
                                return <Option value={item.type_name} key={item.id}>{item.type_name}</Option>
                            })
                        }
                    </Select>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="文章标题" value={title === null ? '' : title} onChange={this.handleInputChange.bind(this)} />
                    <RangePicker value={this.state.rangeDate} style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["创建开始日期", "创建结束日期"]} onChange={this.pickerTime.bind(this)} />
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.selectState.bind(this, '')} >查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary"><Link to={"/article_add"}>添加</Link></Button>
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} pagination={this.state.pagination} rowKey="id" onChange={this.handleTableChange.bind(this)}>
                    <Column title="文章标题" dataIndex="title" key="title" />
                    <Column title="文章分类" dataIndex="type_name" key="type_name" />
                    <Column title="阅读数" dataIndex="view_count" key="view_count" />
                    <Column title="收藏数" dataIndex="collect_count" key="collect_count" />
                    <Column title="分享数" dataIndex="share_count" key="share_count" />
                    <Column title="是否置顶" dataIndex="is_top" key="is_top" render={(value: number): string => value === 1 ? '是' : '否'} />
                    <Column title="文章状态" dataIndex="is_published" key="is_published" render={(value: number): string => value === 0 ? '未发布' : (value == 1 ? '已发布' : '已下架')} />
                    <Column title="发布时间" dataIndex="publish_time" key="publish_time" />
                    <Column title="创建时间" dataIndex="create_date" key="create_date" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Link to={"/article_edit/" + record.id}><Button type="primary">查看</Button></Link>
                                {
                                    record.is_published == 1 ?
                                        <Button type="primary" onClick={this.changeStatus.bind(this, record, 2)}>下架</Button> :
                                        <Button type="primary" onClick={this.changeStatus.bind(this, record, 1)}>发布</Button>
                                }
                                {
                                    record.is_published == 1 ? record.is_top == 1 ?
                                        <Button type="primary" onClick={this.changeIsTop.bind(this, record, 0)}>取消置顶</Button> :
                                        <Button type="primary" onClick={this.changeIsTop.bind(this, record, 1)}>置顶</Button> : ''
                                }
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}